export const hasCalculationResult = (results) => Boolean(
    results && typeof results === 'object'
    && !Array.isArray(results) && !results.code && !results.error
    && results.success !== false && results.isSuccess !== false
    && ['calculatedValue', 'installationCost', 'usedEnergyMCS', 'costSaving', 'yearsForPayback']
        .every(key => Number.isFinite(results[key]))
);
